"use strict";
/* eslint-disable no-new-func */

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _defineProperty = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var acorn = require("acorn");

var findGlobals = require("acorn-globals");

var escodegen = require("escodegen");

var jsGlobals = require("./browser/js-globals.json"); // We can't use the default browserify vm shim because it doesn't work in a web worker.
// "eval" is skipped because it's set to a function that calls `runInContext`:


var jsGlobalEntriesToInstall = Object.entries(jsGlobals).filter(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 1),
      name = _ref2[0];

  return name !== "eval" && name in global;
});

exports.createContext = function (sandbox) {
  // TODO: This should probably use a symbol
  Object.defineProperty(sandbox, "__isVMShimContext", {
    value: true,
    writable: true,
    configurable: true,
    enumerable: false
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = jsGlobalEntriesToInstall[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref5 = _step.value;

      var _ref4 = _slicedToArray(_ref5, 2);

      var globalName = _ref4[0];
      var globalPropDesc = _ref4[1];

      var propDesc = _objectSpread({}, globalPropDesc, {
        value: global[globalName]
      });

      Object.defineProperty(sandbox, globalName, propDesc);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  Object.defineProperty(sandbox, "eval", {
    value: function value(code) {
      return exports.runInContext(code, sandbox);
    },
    writable: true,
    configurable: true,
    enumerable: false
  });
};

exports.isContext = function (sandbox) {
  return sandbox.__isVMShimContext;
};

exports.runInContext = function (code, contextifiedSandbox, options) {
  if (code === "this") {
    // Special case for during window creation.
    return contextifiedSandbox;
  }

  if (options === undefined) {
    options = {};
  }

  var comments = [];
  var tokens = [];
  var ast = acorn.parse(code, {
    allowReturnOutsideFunction: true,
    ranges: true,
    // collect comments in Esprima's format
    onComment: comments,
    // collect token ranges
    onToken: tokens
  }); // make sure we keep comments

  escodegen.attachComments(ast, comments, tokens);
  var globals = findGlobals(ast);

  for (var i = 0; i < globals.length; ++i) {
    if (globals[i].name === "window" || globals[i].name === "this") {
      continue;
    }

    var nodes = globals[i].nodes;

    for (var j = 0; j < nodes.length; ++j) {
      var _nodes$j = nodes[j],
          type = _nodes$j.type,
          name = _nodes$j.name;
      nodes[j].type = "MemberExpression";
      nodes[j].property = {
        name: name,
        type: type
      };
      nodes[j].computed = false;
      nodes[j].object = {
        name: "window",
        type: "Identifier"
      };
    }
  }

  var lastNode = ast.body[ast.body.length - 1];

  if (lastNode.type === "ExpressionStatement") {
    lastNode.type = "ReturnStatement";
    lastNode.argument = lastNode.expression;
    delete lastNode.expression;
  }

  var rewrittenCode = escodegen.generate(ast, {
    comment: true
  });
  var suffix = options.filename !== undefined ? "\n//# sourceURL=" + options.filename : "";
  return Function("window", rewrittenCode + suffix).bind(contextifiedSandbox)(contextifiedSandbox);
};

exports.Script =
/*#__PURE__*/
function () {
  function VMShimScript(code, options) {
    _classCallCheck(this, VMShimScript);

    this._code = code;
    this._options = options;
  }

  _createClass(VMShimScript, [{
    key: "runInContext",
    value: function runInContext(sandbox, options) {
      return exports.runInContext(this._code, sandbox, _objectSpread({}, this._options, {}, options));
    }
  }]);

  return VMShimScript;
}();